import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  getCurrentAccount: () => axios.get(url + 'profile'),

  save: (language, signature) =>
    axios.patch(url + 'profile', { language: language, signature: signature }),

  getByVerificationToken: token => axios.get(url + 'verifications/' + token),

  verify: (token, password) => axios.patch(url + 'verifications/' + token, { password: password }),

  sendResetPasswordMail: username => axios.post(url + `password-resets/${username}`, {}),

  resetPassword: (token, password) =>
    axios.patch(url + `password-resets/${token}`, { password: password }),

  isPasswordResetTokenValid: token => axios.get(url + `password-resets/${token}`)
}



// WEBPACK FOOTER //
// ./src/services/account.js